import { render, staticRenderFns } from "./produce-bar.vue?vue&type=template&id=d223ef0a&scoped=true&"
import script from "./produce-bar.vue?vue&type=script&lang=js&"
export * from "./produce-bar.vue?vue&type=script&lang=js&"
import style0 from "./produce-bar.vue?vue&type=style&index=0&id=d223ef0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d223ef0a",
  null
  
)

export default component.exports